export const enum WEB_LINKS {
  HOME = 'home',
  MAIN = 'main',
  PAYMENT = 'payment',
  PRODUCTS = 'products',
  SETTINGS = 'settings',
  HISTORY_PAYMENT = 'history-payment',
  SETTINGS_REGULATIONS = 'settings-regulations',
  SETTINGS_PASSWORD = 'settings-password',
  SETTINGS_PHONE = 'settings-phone',
  SETTINGS_ACCOUNT_VISIBILITY = 'settings-account-visibility',
  SETTINGS_EMPLOYEE_LIST = 'settings-employee-list',
  SETTINGS_EMPLOYEE_DETAIL = 'settings-employee-detail',
  SETTINGS_EMPLOYEE_OUTLET_ACCESS = 'settings-employee-outlet-access',
  SETTINGS_API_KEY = 'settings-api-key',
  ACCOUNT = 'account',
  ACCOUNT_REQ = 'account-requisites',
  AUTH = 'auth',
  LOGIN = 'login',
  DOCUMENTS = 'documents',
  POS_TERMINAL = 'pos-terminal',
  IMPORTED_FILES = 'importer-files',
  IMPORTED_FILE = 'imported-file',
  PAYMENT_FORM = 'payment-form',
  PAYMENT_DETAIL = 'payment-detail',

  INSTALLMENT = 'installment',
  INSTALLMENT_DETAIL = 'installment-detail',
  INSTALLMENT_ONBOARDING = 'installment-onboarding',

  CARD = 'card',
  CARD_LIMIT = 'limit',
  CARD_BLOCK = 'block',
  POS_MAIN = 'pos',
  POS_ORDER = 'pos-order',
  POS_DETAIL = 'pos-detail',
  LOAN_CLAIMS = 'loan-claims',

  OUTLET_MAIN = 'outlet',
  OUTLET_CREATE = 'outlet-create',
  OUTLET_DETAILS = 'outlet-details',
  OUTLET_EMPLOYEE_CREATE = 'outlet-employee-create',
  OUTLET_EMPLOYEE_DETAILS = 'outlet-employee-details',
  OUTLET_CASH_EDIT = 'outlet-cash-edit',
  OUTLET_INVITED_CASHIERS = 'outlet-invoice-cashiers',
  PERSONAL_QR = 'outlet-personal-qr',
  TWO_GIS = 'two-gis',
  /** Карта филиалов Optima Bank — native-openable WebView page. */
  BANK_OFFICES = 'bank-offices',

  EXCHANGE_RATE = 'exchange-rate',

  QR_CODE = 'qr-code',
  QR_PAYMENT = 'qr-payment',

  BUDGET = 'budget',
  BUDGET_PAYMENT_PROCESS = 'budget-payment-process',

  NPT = 'npt',

  SALARY = 'salary',
  SALARY_STATEMENT_DETAIL = 'salary-statement-detail',
  SALARY_STATEMENT_DETAIL_PROCESSING_FILE = 'salary-statement-detail-processing-file',
  SALARY_CREATE = 'salary-create',
  SALARY_MANUAL = 'salary-manual',

  INVOICE = 'invoice',
  INVOICE_DETAIL = 'invoice-detail',
  INVOICE_LEGAL = 'invoice-legal',
  INVOICE_INDIVIDUAL = 'invoice-individual',

  APPROVE = 'approve',

  NOTIFICATION = 'notification',

  LETTER = 'letter',
  LETTER_CREATE = 'letter-create',
  LETTER_DETAIL = 'letter-detail',
}
